module.exports = __webpack_public_path__ + "img/logo.340844a0.png";